import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { IRecipient } from '@tiendanube/common';
import { useAppDispatch } from 'App/store';
import {
  resetUpdateRecipientAction,
  updateRecipientAction,
  updateRecipientData as updateRecipientDataSelector,
  updateRecipientResponseStatus,
} from '../recipientSlice';

const useUpdateRecipient = () => {
  const dispatch = useAppDispatch();
  const updateRecipientData = useSelector(updateRecipientDataSelector);
  const status = useSelector(updateRecipientResponseStatus);

  const updateRecipient = useCallback(
    (storeId: string, recipient: IRecipient) => {
      dispatch(updateRecipientAction({ storeId, recipient }));
    },
    [dispatch],
  );

  const resetUpdateRecipientData = useCallback(() => {
    dispatch(resetUpdateRecipientAction());
  }, [dispatch]);

  return {
    resetUpdateRecipientData,
    ...status,
    updateRecipient,
    updateRecipientData,
  };
};

export default useUpdateRecipient;
